import { useTranslation } from "react-i18next";
import ContainerMd from "../../../components/Layouts/ContainerMd";
import LogoWithLanguage from "../../../components/logo-with-language/LogoWithLanguage";
import PaymentCard from "../../../components/payment/PaymentCard";
import SubscriptionDetails from "../../../components/payment/SubscriptionDetails";
import { useEffect, useState } from "react";
import { makeApiRequest } from "../../../helpers";
import { ApiResponse } from "../../../api/apiResponse";
import moment from "moment";
import {
  candidateProgramPayment,
  IndexCandidatePayments,
} from "../../../api/endpoints/candidate/payment";
import SubscriptionsModel from "../../../api/models/SubscriptionsModel";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function QualifiedPaymentPage() {
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.payment",
  });
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const Navigate = useNavigate();
  const IndexPayments = async () => {
    let res = await IndexCandidatePayments();
    const subscriptions: SubscriptionsModel[] =
      SubscriptionsModel.fromApiResponse(res.data);
    subscriptions.forEach((subscription: SubscriptionsModel) => {
      if (
        subscription.subscriptionType === "program" &&
        subscription.isActive
      ) {
        Navigate(`/candidate/schedule`);
      }
    });
    setIsLoading(false);
  };

  useEffect(() => {
    IndexPayments();
  }, []);
  const getPaymentToken = () => {
    const data = {
      expired_at: moment().add(30, "days").format("DD/MM/YYYY"),
      amount: 50000,
    };
    makeApiRequest(
      () => candidateProgramPayment(data),
      (response: ApiResponse) => {
        const { data } = response;
        const { payments } = data;
        if (payments.length)
          setClientSecret(payments[payments?.length - 1]?.client_secret);
      }
    );
  };

  useEffect(() => {
    getPaymentToken();
  }, []);
  return (
    <>
      {isLoading ? (
        <div className="w-full flex justify-center items-center h-screen ">
          <LoadingSpinner size={50} />
        </div>
      ) : (
        <>
          <ContainerMd containerClassName="py-4">
            <div className="w-full h-full  px-4 md:px-6">
              <LogoWithLanguage />
              <div className="w-full border-b border-gray-200 pb-2 pt-6">
                <h3 className="w-full mb-2 text-3xl text-gray-700 font-bold">
                  {t("paymentSubscriptions")}
                </h3>
                <p className="w-full text-gray-500 text-lg leading-6 font-normal">
                  {t("paymentOneTime")}
                </p>
              </div>
              <div className="w-full  grid grid-cols-1 gap-6  items-start mt-6">
                <div className="w-full">
                  <SubscriptionDetails cost={"500.00"} paymentDetails={false} />
                </div>
                <div className="w-full rtl:pl-4 ltr:pr-4 md:ltr:pr-6 md:rtl:pl-6">
                  {!!clientSecret && (
                    <PaymentCard
                      redirectTo={`${window.location.origin}/candidate/dashboard/home`}
                      clientSecret={clientSecret}
                    />
                  )}
                </div>
              </div>
            </div>
          </ContainerMd>
        </>
      )}
    </>
  );
}
